import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { SubunitSettingsDialogComponent } from './subunit-settings-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class SubunitSettingsDialogService {
  constructor(private dialog: DialogService) {}

  open(mainRentalId: string, rentalId?: string) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      data: { rentalId, mainRentalId },
    }
    return this.dialog.openFixedDialog(SubunitSettingsDialogComponent, defaultConfig)
  }
}
